function Ctrl($scope, metaTagService) {
  metaTagService.set({
    title: 'Tablelist Promo Codes | Tablelist',
    description: 'Coupons and Promo codoes for new users.'
  });
}

Ctrl.$inject = [
  '$scope',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/coupons/couponsCtrl.js